/**
 * Custom Quick Add - Variant Buttons
 * Adds items directly to cart and opens the cart drawer
 */

document.addEventListener('DOMContentLoaded', function () {
  initQuickAddCustom();
});

// Re-initialize when sections are loaded (for pagination, etc.)
document.addEventListener('shopify:section:load', function () {
  initQuickAddCustom();
});

function initQuickAddCustom() {
  const quickAddButtons = document.querySelectorAll('.quick-add-custom__button:not([data-initialized])');

  quickAddButtons.forEach((button) => {
    button.setAttribute('data-initialized', 'true');
    button.addEventListener('click', handleQuickAddClick);
  });
}

async function handleQuickAddClick(event) {
  event.preventDefault();
  event.stopPropagation();

  const button = event.currentTarget;

  if (button.disabled || button.classList.contains('loading')) {
    return;
  }

  const variantId = button.dataset.variantId;
  if (!variantId) {
    console.error('Quick add: No variant ID found');
    return;
  }

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  // Set loading state
  button.classList.add('loading');
  const spinner = button.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  try {
    const formData = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
        },
      ],
    };

    // Add sections for cart drawer update
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.sections = cart.getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json().catch(() => ({}));

    // Handle error responses (422, 400, etc.)
    if (!response.ok || data.status === 422 || data.status === 'bad_request' || data.errors) {
      const errorMessage = data.errors || data.description || data.message || 'Unable to add item to cart';
      console.error('Cart add failed:', response.status, errorMessage);

      // Show user-friendly error message
      showQuickAddError(button, errorMessage);

      // Check if sold out or max quantity reached
      const errorMsgLower = errorMessage.toLowerCase();
      if (errorMsgLower.includes('sold out') || errorMsgLower.includes('not available')) {
        button.disabled = true;
        button.classList.add('quick-add-custom__button--sold-out');
      }

      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'quick-add-custom',
          productVariantId: variantId,
          errors: data.errors || data.description,
          message: data.message,
        });
      }
      return;
    }

    // Success - update cart and open drawer
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'quick-add-custom',
        productVariantId: variantId,
        cartData: data,
      });
    }

    if (cart && typeof cart.renderContents === 'function') {
      // Ensure drawer is not treated as empty so new items are visible
      if (cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
      cart.renderContents(data);
    } else {
      window.location = window.routes.cart_url;
    }
  } catch (error) {
    console.error('Quick add error:', error);
    showQuickAddError(button, 'Unable to add item to cart. Please try again.');
  } finally {
    // Remove loading state
    button.classList.remove('loading');
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
  }
}

/**
 * Display an error message near the button
 */
function showQuickAddError(button, message) {
  // Remove any existing error messages
  const existingError = button.closest('.quick-add-custom')?.querySelector('.quick-add-custom__error');
  if (existingError) {
    existingError.remove();
  }

  // Create error element
  const errorEl = document.createElement('div');
  errorEl.className = 'quick-add-custom__error';
  errorEl.textContent = message;
  errorEl.setAttribute('role', 'alert');

  // Insert after the variants container
  const container = button.closest('.quick-add-custom');
  if (container) {
    container.appendChild(errorEl);

    // Auto-remove after 5 seconds
    setTimeout(() => {
      errorEl.remove();
    }, 5000);
  }
}
